<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <!-- <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button> -->
                         <el-input
                            size="small"
                            style="width:200px;margin-left:0px;"
                            placeholder="请输入用户手机号"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.type" clearable placeholder="类型">
                            <el-option key="1" label="充值" value="1"> </el-option>
                            <el-option key="2" label="提现" value="2"> </el-option>
                        </el-select>

                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.status" clearable placeholder="审批状态">
                            <el-option key="1" label="待审核" value="1"> </el-option>
                            <el-option key="2" label="成功" value="2"> </el-option>
                            <el-option key="3" label="失败" value="3"> </el-option>
                        </el-select>
                        <el-date-picker
                         value-format="yyyy-MM-dd HH:mm:ss"
                        size="small" style="width:300px;margin-left:30px"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :height="bodyHeight-130"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                            prop="MemberId"
                            label="用户Id">
                        </el-table-column>
                        <el-table-column
                            prop="Phone"
                            label="手机号">
                        </el-table-column>
                        <el-table-column
                            label="金额">
                            <template slot-scope="scope">
                                  <el-link type="primary">￥{{scope.row.Money}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            label="申请时间">
                        </el-table-column>
                        <el-table-column
                            label="转账凭证/提现卡号">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.Type==1" @click="showImg(scope.row)" icon="el-icon-picture" type="primary">{{scope.row.Transferor}}</el-link>
                                <el-tooltip  v-else  class="item" effect="dark" placement="bottom">
                                    <div slot="content">
                                        <p>卡号： {{scope.row.CardNo}}</p>
                                        <p>开户行： {{scope.row.AccountBankName}}</p>
                                    </div>
                                     <el-link  icon="el-icon-warning-outline"  type="primary">{{scope.row.AccountName}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="类型">
                            <template slot-scope="scope">
                                  <el-tag
                                  size="mini"
                                        :type="scope.row.Type==1?'danger':'success'"
                                        effect="dark">
                                        {{ scope.row.Type==1?'充值':'提现' }}
                                    </el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="审核信息">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.ReviewManagerName==''" icon="el-icon-user" type="info">暂无</el-link>
                                <el-tooltip  v-else  class="item" effect="dark" placement="bottom-start">
                                    <div slot="content">
                                        时间：{{scope.row.ReviewTime}}<br/><br/>
                                        备注：{{scope.row.ReviewRemark}}<br/><br/>
                                    </div>
                                    <el-link icon="el-icon-user" type="primary">{{scope.row.ReviewManagerName}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" v-if="scope.row.Status==1">待审核</el-tag>
                                <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.Status==2">成功</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else-if="scope.row.Status==3">失败</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作">
                            <template slot-scope="scope">
                                <el-tooltip class="item" v-if="scope.row.Status==1" effect="dark" content="审核通过" placement="bottom">
                                    <el-button type="success" size="mini" @click="pass(scope.row)"  icon="el-icon-check" circle></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" v-if="scope.row.Status==1" effect="dark" content="审核不通过" placement="bottom">
                                    <el-button type="danger"  size="mini" @click="over(scope.row)"  icon="el-icon-close" circle></el-button>
                                </el-tooltip>                            
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-image-viewer 
                v-show="showViewer" 
                :on-close="closeImg" 
                :url-list="[url]" />
    </div>
</template>
<script>
import { transactionGet,transactionOver,transactionPass} from '@/request.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    components: {
        ElImageViewer 
    },
    data(){
        return {
            url:"",
            showViewer:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                status:"",
                createTimes:[],
            },
            tableData:[],

        }
    },

    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){

    },
    methods: {
        pass(scope){
            if(scope.Type==1){
                this.$confirm('通过之后充值金额将直接加入用户余额，确认操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    transactionPass({id:scope.Id},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '充值成功',
                                type: 'success'
                            });
                            scope.Status=2;
                            scope.ReviewTime=res.Result.ReviewTime;
                            scope.ReviewManagerName=res.Result.ReviewManagerName;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {

                });
            }else{
                
                this.$confirm('确认通过该提现申请吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    transactionPass({id:scope.Id},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '提现成功',
                                type: 'success'
                            });
                            scope.Status=2;
                            scope.ReviewTime=res.Result.ReviewTime;
                            scope.ReviewManagerName=res.Result.ReviewManagerName;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {
      
                });
            }
            
        },
        over(scope){
            this.$prompt('请填写不通过原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                }).then(({ value }) => {
                    transactionOver({remark:value,id:scope.Id},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.Status=3;
                            scope.ReviewTime=res.Result.ReviewTime;
                            scope.ReviewManagerName=res.Result.ReviewManagerName;
                            scope.ReviewRemark=value;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消操作'
                });       
            });
        },
        closeImg(){
            this.showViewer=false;
        },
        showImg(scope){
            this.url=scope.ImgUrl;
            this.showViewer=true;
        },
        query(){
            this.isLoading=true;
            transactionGet({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
                type:this.queryModel.type,
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(this.queryModel.createTimes),
            },(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                status:"",
                createTimes:[]
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>